import { Stack, Typography } from '@mui/material';
import { EmptyState } from 'design-system';
import { PlaceholderView } from 'interfaces/graphqlViews';
import ActionButton from 'components/ActionButton';
import BtnIcon from 'components/BtnIcon';
import { ButtonIcon } from 'generated/graphql';

/** A group's or display's placeholder, as the server words it. */
export const EmptyTableState = ({
  placeholder,
  searchTerm = '',
  iconSize,
  onRefresh,
}: {
  placeholder?: PlaceholderView | null;
  searchTerm?: string;
  iconSize?: number;
  onRefresh?: () => void;
}) => {
  const title = searchTerm ? `No results for "${searchTerm}"` : (placeholder?.title ?? 'No data available');

  return (
    <EmptyState
      title={title}
      icon={({ size }) => <BtnIcon icon={placeholder?.icon ?? ButtonIcon.FolderOff} size={size} />}
      iconSize={iconSize}
    >
      {/* The subtitle and action are for nothing being there at all, not for a
          search that matched nothing. */}
      {!searchTerm && (placeholder?.subtitle || placeholder?.button) && (
        <Stack sx={{ alignItems: 'center', gap: 2, mt: 0.5 }}>
          {placeholder.subtitle && <Typography sx={{ color: 'grey.600' }}>{placeholder.subtitle}</Typography>}
          {placeholder.button && <ActionButton {...placeholder.button} onMutate={onRefresh} />}
        </Stack>
      )}
    </EmptyState>
  );
};
